import type { ProLayoutProps } from "@ant-design/pro-components";

/**
 * @name
 */
const Settings: ProLayoutProps & {
  pwa?: boolean;
  logo?: string;
} = {
  navTheme: "light",
  colorPrimary: "#1677FF",
  layout: "side",
  contentWidth: "Fluid",
  fixedHeader: true, // 固定头部 → 控制显示
  fixSiderbar: true, // 固定侧边栏
  pwa: true,
  logo: "/logo.png",
  token: {},
  splitMenus: false,
  siderMenuType: "sub",
  footerRender: false,
};

export default Settings;
